import { FC, ReactElement } from 'react';
import { NavLink } from 'react-router-dom';

import useBreadcrumbs from 'use-react-router-breadcrumbs';

interface IProps {
    pageTitle: string;
    title?: string;
}

const BreadCrumb: FC<IProps> = ({ pageTitle }): ReactElement => {
    //-----------------------------------------------------------
    document.title = `${pageTitle} | Antar Back Office`;
    //-----------------------------------------------------------
    const breadcrumbs = useBreadcrumbs();
    //-----------------------------------------------------------
    return (
        <div className="flex flex-col gap-2 py-4 md:flex-row md:items-center print:hidden">
            <div className="grow">
                <h5 className="text-16">{pageTitle}</h5>
            </div>
            <ul className="flex shrink-0 items-center gap-2 text-sm font-normal">
                {breadcrumbs.map(({ match, breadcrumb }, index) =>
                    breadcrumbs.length - 1 === index ? (
                        <li className={`font-extrabold`}>{match.pathname === `/` ? `Dashboard` : breadcrumb}</li>
                    ) : (
                        <NavLink key={match.pathname} to={match.pathname}>
                            <li
                                className="relative before:absolute
                                    before:-top-[3px] before:font-remix before:text-[18px]
                                    before:text-slate-400 before:content-['\ea54'] hover:underline
                                    ltr:pr-4 ltr:before:-right-1 rtl:pl-4 rtl:before:-left-1"
                            >
                                {match.pathname === `/` ? `Dashboard` : breadcrumb}
                            </li>
                        </NavLink>
                    )
                )}
            </ul>
        </div>
    );
};

export default BreadCrumb;
